import { Card, Stack, Typography } from "@mui/material";

export default function HealthPage() {
    const styles = {
        page: {
            height: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          
        },
        card: {
            p: 4,
            gap: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: '1px solid #ffc700',
            width:'400px'
        },
    };

    return (
        <Stack sx={styles.page}>
            <Card sx={styles.card}>
                <Typography sx={{ fontSize: { xs: '40px' }, fontWeight: 600, marginTop: { xs: 4, sm: 2 } }} pb={1} >
                    Health Check
                </Typography>
                <Typography sx={{ fontSize: { xs: '22px' }, fontWeight: 600, marginTop: { xs: 4, sm: 2 } }} pb={1}>
                    HTTP 200 OK
                </Typography>
            </Card>
        </Stack>
    );
}
